/*
 * Authors: mariushirjanu
 * Created: 28/09/2021
 */

import { HttpDataService } from '../http/http-data.service';

import { IInvoiceHeader, ILocationExtended, IPaymentResult } from '../../../type_definitions/datatypes';
import { Injectable } from '@angular/core';
import { IExternalValue } from '../../main/order/entry/location/order-entry-location-data.service';
import { IOrderFeesHeader } from '../../main/invoice/order-fees/order-fees-data.service';
import { IMailInvoiceRequest } from '../mail-invoice/mail-invoice.service';

export interface IInvoiceInfo {
  location:ILocationExtended;
  updateExternalId:boolean;
  externalIdValue:IExternalValue;
  createNewLocation?:boolean;
}

@Injectable()
export class InvoiceDataService {
  constructor(
    private httpDataService:HttpDataService
  ) {
    /***/
  }

  public loadInvoiceHeader(id:number):Promise<IInvoiceHeader> {
    return this.httpDataService.doGET(
      `rest/invoices/${id}/header`,
      undefined,
      undefined,
      'Error loading invoice'
    );
  }

  public payInvoice(invoiceId:number, cardId:number):Promise<IPaymentResult> {
    return this.httpDataService.doPOST(
      `rest/payment/invoices/${invoiceId}/payment`,
      { cardId },
      undefined,
      undefined,
      'Error paying invoice'
    );
  }

  public updateInvoiceInfo(orderId:number, payload:IInvoiceInfo):Promise<IInvoiceInfo> {
    return this.httpDataService.doPOST(
      `rest/orderentry/orders/${orderId}/invoiceinfo`,
      undefined,
      payload,
      undefined,
      'Error saving invoice info'
    );
  }

  public sendInvoice(data:IMailInvoiceRequest, invoiceId:number):Promise<IOrderFeesHeader> {
    return this.httpDataService.doPOST(
      'rest/invoices/send-invoice',
      { invoiceId },
      data,
      undefined,
      'Error sending invoice'
    );
  }
}
